<template>
  <svg :width="size" :height="size" fill="currentColor" :class="classIcon">
    <use v-bind:xlink:href="`${BootstrapIcons}#${icon}`" />
  </svg>
</template>

<script setup>
import { defineProps } from 'vue';
import BootstrapIcons from "bootstrap-icons/bootstrap-icons.svg";

defineProps({
  icon: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    required: false,
    default: "18"
  },
  classIcon: {
    type: String,
    required: false,
    default: ""
  }
});
</script>

